"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Huan = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
class Huan extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.HUAN,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L29',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br.br;
                    b.tradeFleet().any.tradeFleet().asterix();
                    b.br.br;
                }),
                description: 'All opponents cannot trade next generation. Gain 1 permanent trade fleet.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        player.increaseFleetSize();
        game.syndicatePirateRaider = player.id;
        game.log('All players except ${0} may not trade next generation.', (b) => b.player(player));
        this.isDisabled = true;
        return undefined;
    }
}
exports.Huan = Huan;
//# sourceMappingURL=Huan.js.map